import { ref, onMounted } from 'vue';
import axios from 'axios';
import { EnrollmentTerm } from "@/types/school";
import { ServiceType } from '@/models/loans';

export function useDrawData(lenderId: number, productId: number, programTypeId: number) {
	const certificationMethodOptions = ref<ServiceType[]>([]);
	const drawStatusOptions = ref<ServiceType[]>([]);
	const enrollmentTermOptions = ref<EnrollmentTerm[]>([]);
	const schoolLevelOptions = ref<ServiceType[]>([]);

	async function getCertificationMethodsAsync() {
		try {
			const response = await axios.get('/api/loantypes/CertificationMethod');
			certificationMethodOptions.value = response.data.results.map((type: ServiceType) => ({
				id: type.id,
				name: type.name
			}));
		} catch (error) {
			console.error('Error fetching certification methods:', error);
		}
	}

	async function getDrawStatusesAsync() {
		try {
			const response = await axios.get('/api/loantypes/DrawStatusType');
			drawStatusOptions.value = response.data.results.map((type: ServiceType) => ({
				id: type.id,
				name: type.name
			}));
		} catch (error) {
			console.error('Error fetching draw statuses:', error);
		}
	}

	async function getEnrollmentTermsAsync(filter: boolean, schoolId: number, schoolCode?: string | null | undefined, schoolBranch?: string | null | undefined) {
		try {
			const response = await axios.get(`/api/schools/${schoolId}/lender/${lenderId}/product/${productId}/program/${programTypeId}/enrollment-terms?filter=${filter}&schoolCode=${schoolCode}&schoolBranch=${schoolBranch}`);
			return response.data as EnrollmentTerm[];
		} catch (error) {
			console.error('Error fetching enrollment terms:', error);
		}
	}

	async function getSchoolLevelsAsync() {
		try {
			const response = await axios.get(`/api/types/SchoolLevels?programTypeId=${programTypeId}`);
			schoolLevelOptions.value = response.data.results;
		} catch (error) {
			console.error('Error fetching Grade Level options:', error);
		}
	}

	onMounted(async () => {
		await getSchoolLevelsAsync();
		await getCertificationMethodsAsync();
		await getDrawStatusesAsync();
	});

	return {
		certificationMethodOptions,
		drawStatusOptions,
		enrollmentTermOptions,
		schoolLevelOptions,
		getEnrollmentTermsAsync
	};
}
